import { observer } from "mobx-react";
import React, { ReactNode, useContext } from "react";

import { LookupContext } from "@gp/components";
import { EventOffer } from "@gp/offer";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { TeamItem } from "./TeamItem";

export const EventTeamsInfoCore = observer(function EventTeamsInfoCore({
	store,
	event,
	children,
}: {
	store: EventViewStore | AdditionalOfferViewStore;
	event: EventOffer;
	children: ReactNode;
}) {
	const { teams, tournaments } = useContext(LookupContext);

	const homeTeam = teams.get(event.teamOneId || "");
	const awayTeam = teams.get(event.teamTwoId || "");

	if (!homeTeam || !awayTeam) {
		console.error(
			`Failed to find team look up for ${event.teamOneId} or for ${event.teamTwoId} on ${event.id}`
		);
		return null;
	}

	const winLostDrawStats = store.sportStatisticsStore.winLostDrawStats;
	const tournament = tournaments.get(event.tournamentId);

	return (
		<div className="event__details">
			<TeamItem
				tournament={tournament}
				mainTeam={homeTeam}
				opponentTeam={awayTeam}
				form={winLostDrawStats?.get(homeTeam.abrv) || null}
			/>

			{children}

			<TeamItem
				tournament={tournament}
				mainTeam={awayTeam}
				opponentTeam={homeTeam}
				form={winLostDrawStats?.get(awayTeam.abrv) || null}
			/>
		</div>
	);
});
